import { useState } from 'react';
// mantine
import { Button, Popover, UnstyledButton, Textarea } from '@mantine/core';
import { useDisclosure, useClickOutside } from '@mantine/hooks';
// utils
import { TSessionsData } from '@newo/api/gateway';
import { cn } from '@/utils';
import { POPOVER_PORTAL } from '@/constants';

interface CommentPopoverProps {
    sessionId: string;
    comment: string;
    onSave: (sessionId: string, { comment }: TSessionsData) => void;
}

const CommentPopover = ({
    comment,
    sessionId,
    onSave
}: CommentPopoverProps) => {
    const [isOpened, handlers] = useDisclosure(false);
    const [value, setValue] = useState(comment);
    const ref = useClickOutside(() => {
        handlers.close();
    });

    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setValue(event.currentTarget.value);
    };

    const handleSave = () => {
        onSave(sessionId, { comment: value.trim() });
        handlers.close();
    };

    const handleOpen = () => {
        handlers.open();
    };

    const handleClose = () => {
        handlers.close();
    };

    return (
        <Popover
            withArrow
            opened={isOpened}
            portalProps={{
                target: `#${POPOVER_PORTAL}`
            }}
            position="bottom"
            shadow="md"
            width={300}
        >
            <Popover.Target>
                <UnstyledButton
                    className={cn('text-sm', {
                        'text-gray-6 italic': !comment
                    })}
                    onClick={handleOpen}
                >
                    {comment || 'Add a comment'}
                </UnstyledButton>
            </Popover.Target>
            <Popover.Dropdown className="flex flex-col gap-4" ref={ref}>
                <Textarea
                    placeholder="Enter your comment"
                    rows={5}
                    value={value}
                    onChange={handleChange}
                />
                <div className="flex justify-between">
                    <UnstyledButton
                        className="text-gray-6 text-xs"
                        onClick={handleClose}
                    >
                        Close
                    </UnstyledButton>
                    <Button size="xs" onClick={handleSave}>
                        Save
                    </Button>
                </div>
            </Popover.Dropdown>
        </Popover>
    );
};

export default CommentPopover;
